angular.module("smartorg.r6.navs.reportOptions").directive("reportFilter", [function () {
        return {
            restrict: "E",
            template: require('../../template/filter.html'),
            transclude: true,
            scope: {
                /**
                 * Display label for this filter.
                 */
                filterTitle: '@',
                /**
                 * Tag object, including entries. Use Tag class defined in
                 * report-option-tags.js.
                 */
                selectedTag: '='
            },
            link: function (scope) {
                scope.$on('LOAD_OPTION_FILTERS', function (event, args) {
                    // Cannot use angular copy here.
                    // It will mess up the object reference.
                    // Result in filter model be empty.
                    scope.filterConfig = args.tags;
                });
                /**
                 * Select all options.
                 */
                scope.selectAllOptions = function () {
                    if (scope.selectedTag) {
                        scope.selectedTag.selectAllEntries();
                    }
                };
                /**
                 * Invert all selection.
                 * Selected -> unselect.
                 * Unselected -> select.
                 */
                scope.invertSelect = function () {
                    if (scope.selectedTag) {
                        scope.selectedTag.invertSelectEntries();
                    }
                };
            }
        };
    }]);
//# sourceMappingURL=filter-directive.js.map


// WEBPACK FOOTER //
// ./app/widgets/navigation/report-options/app/js/plumbing/filter-directive.js